'use client';

import Script from 'next/script';
import { useAfterInteraction } from '@/lib/use-after-interaction';

const GA_ID = 'G-8N05CT90MV';
const TAWK_SRC = 'https://embed.tawk.to/6a33c4fb4387da1d4a769c59/1jrd3iucn';

// Google Analytics e Tawk.to pesano ~300 KB di JS: li carichiamo alla prima
// interazione (o poco dopo il load) così non rallentano il rendering iniziale.
const LOAD_TIMEOUT_MS = 3500;

export default function ThirdPartyScripts() {
  const ready = useAfterInteraction(LOAD_TIMEOUT_MS);
  if (!ready) return null;

  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`} strategy="afterInteractive" />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}');
        `}
      </Script>
      <Script id="tawk-to" strategy="afterInteractive">
        {`
          var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
          (function(){
          var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
          s1.async=true;
          s1.src='${TAWK_SRC}';
          s1.charset='UTF-8';
          s0.parentNode.insertBefore(s1,s0);
          })();
        `}
      </Script>
    </>
  );
}
